import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import { useApp } from '@context/AppContext';

const PORTAL_TYPE = 'borrower';
const ACCOUNT_GROUP_TYPE = 'account';

export const PostHogAnalytics = () => {
  const posthog = usePostHog();
  const { user, companyId, companyInfo, isAuthorized } = useApp();

  useEffect(() => {
    if (!posthog || !isAuthorized || !user) return;

    const companyName = companyInfo?.publishName ?? '';

    posthog.identify(user.sourceRecId, {
      email: user.email,
      name: user.name,
      loan_account: user.account,
      company_id: companyId,
      company_name: companyName,
      portal_type: PORTAL_TYPE,
    });

    if (companyId) {
      posthog.group(ACCOUNT_GROUP_TYPE, companyId, {
        company_name: companyName,
        company_id: companyId,
      });
    }
  }, [posthog, user, companyId, companyInfo, isAuthorized]);

  return null;
};

export default PostHogAnalytics;
